import React, { FC } from 'react';

import ExitBrightHorizonsPartnershipModal from '@rover/pages/src/bright-horizons/GlobalUI/Modals/ExitPartnership/ExitBrightHorizonsPartnershipModal';
import usePageContext from '@rover/react-lib/src/context/usePageContext';

const GlobalModals: FC = () => {
  const { pageName } = usePageContext();
  return pageName !== 'ssr-bh-hub' ? <ExitBrightHorizonsPartnershipModal /> : null;
};
export default GlobalModals;
